import { animate, AnimationEvent, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UrlConstants } from '@app/core/constants/url.constants';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss'],
  animations: [
    trigger('openClose', [
      state(
        'open',
        style({
          opacity: 1
        })
      ),
      state(
        'stay',
        style({
          opacity: 1
        })
      ),
      state(
        'closed',
        style({
          opacity: 0
        })
      ),
      transition('* => closed', [animate('0.1s')]),
      transition('* => open', [animate('0.1s')]),
      transition('* => stay', [animate('0.3s')])
    ])
  ]
})
export class RedirectComponent {
  animateState = 'open';

  constructor(private router: Router, private route: ActivatedRoute) {}

  redirect(event: AnimationEvent) {
    if (event.toState == 'open') {
      this.animateState = 'stay';
    }

    if (event.toState == 'stay') {
      this.animateState = 'closed';
    }

    if (event.toState == 'closed') {
      const url = this.route.snapshot.queryParams['redirectUrl'];
      if (url) {
        this.router.navigateByUrl(url);
      } else {
        this.router.navigate([UrlConstants.appBaseUrl]);
      }
    }
  }
}
